import $api from 'http'

export const updateProfilePhoto = photo => {
  const data = new FormData()
  data.append('photo', photo)
  return $api.patch('/account/profile/photo/', data)
}

export const updateProfilePin = data => $api.post('/account/profile/pin/', data)
export const updateProfilePassword = data => $api.post('/account/profile/password/', data)
export const updateProfileLanguage = language => $api.patch('/account/profile/language/', { language })
